

import { AiOutlineInfoCircle } from "react-icons/ai";
function Danger({message}) {
    return (
      <div className="text-blue-600 font-medium flex items-center">
        <AiOutlineInfoCircle className="mr-2 text-2xl font-bold"></AiOutlineInfoCircle>
        <p>{message}</p>
      </div>
    );
  }

  export default Danger;